module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "go"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Go"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "go_banner"
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v("iGo")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('go_banner_content'))), _c('br'), _vm._v(_vm._s(_vm.$t('go_banner_content1'))), _c('br'), _vm._v(_vm._s(_vm.$t('go_banner_content2')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "go_content"
  }, [_c('div', {
    staticClass: "mogo_list"
  }, [_c('Row', _vm._l((_vm.mogo_list), function(list, index) {
    return _c('i-col', {
      key: index,
      attrs: {
        "lg": 8,
        "md": 8,
        "sm": 12,
        "xs": 24
      }
    }, [_c('div', {
      staticClass: "mogo_list_content"
    }, [_c('a', [_c('img', {
      attrs: {
        "src": list.goods_img
      },
      on: {
        "click": function($event) {
          _vm.detail(list.goods_alias, list.goods_id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "list_info"
    }, [_c('p', {
      staticClass: "font_mid"
    }, [_vm._v("\n                                " + _vm._s(list.goods_name) + "\n                            ")]), _vm._v(" "), _c('p', {
      staticClass: "font_small",
      domProps: {
        "innerHTML": _vm._s(list.goods_remark)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "list_addCart"
    }, [(list.store_count == 0) ? _c('div', {
      staticClass: "list_btn"
    }, [_c('button', {
      staticStyle: {
        "background": "#ccc"
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.$t('store_mainpage_out_of_stock')) + "\n                                ")])]) : _c('div', {
      staticClass: "list_btn"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.addToCart(list.goods_id)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.$t('add_to_cart')) + "\n                                ")])]), _vm._v(" "), _c('a', {
      staticClass: "font_small",
      on: {
        "click": function($event) {
          _vm.detail(list.goods_alias, list.goods_id)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.$t('learn_details')) + " "), _c('Icon', {
      attrs: {
        "type": "arrow-right-c"
      }
    })], 1)])])])
  }))], 1)]), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c7ea0b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Go/Go.vue
// module id = 779
// module chunks = 0